export interface ValidationResult {
  isValid: boolean;
  errorMessage?: string;
}

export type ValidationRule = (value: string, fieldName: string) => ValidationResult;

// Required rule
export const requiredRule: ValidationRule = (value, fieldName) => {
  if (!value) {
    return { isValid: false, errorMessage: `${fieldName} is verplicht.` };
  }
  return { isValid: true };
};

// Email rule
export const emailRule: ValidationRule = (value, fieldName) => {
  const emailRegex = /(^([A-Za-z0-9._%+\-]{0,128}@[A-Za-z0-9.\-]{0,128}\.[A-Za-z]{2,10})$)/;
      
  if (value && !emailRegex.test(value)) {
    return { isValid: false, errorMessage: `${fieldName} moet een geldig e-mailadres zijn.` };
  }
  return { isValid: true };
};

// Combine rules for flexibility
export const applyRules = (value: string, fieldName: string, rules: ValidationRule[]): ValidationResult => {
  for (const rule of rules) {
    const result = rule(value, fieldName);
    if (!result.isValid) {
      return result; // Stop at the first failure
    }
  }
  return { isValid: true };
};
  